
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import store from '@/store';

export interface ErrorText {
  title: string;
  message?: string;
}

@Component
export default class BoxError extends Vue {
  private name = 'BoxError';

  goBack() {
    if (window.history.length > 1) {
      this.$router.go(-1)
    } else {
      this.$router.push({ name: 'home' }) // デフォルトの遷移先
    }
  }

}
